import { useMutation } from '@tanstack/react-query';
import { setPassword } from './api';

export const useSetPasswordMutation = () =>
  useMutation({ mutationFn: setPassword });
